import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M4.842 7.286h7.971a.548.548 0 0 1 0 1.095h-7.97l3.711 3.712a.548.548 0 0 1-.774.774L3.133 8.221a.546.546 0 0 1-.16-.386v-.003c0-.14.053-.28.16-.386L7.78 2.799a.548.548 0 0 1 .774.775L4.842 7.286Z"
    }
  )
);
var SvgArrowBackOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var ArrowBackOutlined_default = SvgArrowBackOutlined;

export { ArrowBackOutlined_default as default };
